<template>
  <div>
    <AdminDashboard v-if="this.$store.state.user.currentGroups.includes('Dirección')" />
  </div>
</template>

<script>

import AdminDashboard from '../components/dashboards/adminDashboard.vue'
// import adminDashboard from '../components/dashboards/adminDashboard.vue'
// import teacherDashboard from '../components/dashboards/teacherDashboard.vue'

export default {
  name: 'IndexPage',
  data () {
    return {
      name: 'asd'
    }
  },
  components: {
    AdminDashboard
  },
  async created () {
    console.log('groups ', this.$store.state.user.currentGroups)
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped></style>
